import { useTranslation } from 'react-i18next';
import type { InvoiceStatusType } from 'api/swagger';
import { InvoiceStatus } from 'types/invoice-status';
import { ALL_INVOICE_STATUSES } from './constants';
import { STATUSES_EXCLUDING_LEGAL_ACTIONS } from './utils';

export const usePreparedStatuses = (currentStatus: InvoiceStatusType) => {
  const { t } = useTranslation('invoice');

  const statusTransitions: Record<InvoiceStatusType, InvoiceStatusType[]> = {
    [InvoiceStatus.NeedAction]: [
      InvoiceStatus.WaitingOriginal,
      InvoiceStatus.OriginalSent,
      InvoiceStatus.Waiting,
      InvoiceStatus.Cancelled,
    ],
    [InvoiceStatus.WaitingOriginal]: [
      InvoiceStatus.NeedAction,
      InvoiceStatus.OriginalSent,
      InvoiceStatus.Waiting,
      InvoiceStatus.Cancelled,
    ],
    [InvoiceStatus.OriginalSent]: [
      InvoiceStatus.NeedAction,
      InvoiceStatus.WaitingOriginal,
      InvoiceStatus.Waiting,
      InvoiceStatus.Cancelled,
    ],
    [InvoiceStatus.Problem]: ALL_INVOICE_STATUSES,
    [InvoiceStatus.Loss]: ALL_INVOICE_STATUSES,
    [InvoiceStatus.LegalActions]: ALL_INVOICE_STATUSES,
    [InvoiceStatus.Waiting]: STATUSES_EXCLUDING_LEGAL_ACTIONS,
    [InvoiceStatus.PartiallyPaid]: STATUSES_EXCLUDING_LEGAL_ACTIONS,
    [InvoiceStatus.Completed]: STATUSES_EXCLUDING_LEGAL_ACTIONS,
    [InvoiceStatus.Cancelled]: [InvoiceStatus.NeedAction],
  };

  return ALL_INVOICE_STATUSES.map((status) => ({
    label: t(`status_${status}`),
    value: status,
    disabled: !statusTransitions[currentStatus].includes(status),
  }));
};
